import { LEARN } from 'constants/actionTypes';
import ShallowNormalizer from 'utils/ShallowNormalizer';
import { getNormalizedContentIdentifiersForContent } from 'selectors/learn/helpers';

export default (normalized = {}, action) => {
  switch (action.type) {
    case LEARN.CONTENTS.RECEIVE: {
      const normalizer = new ShallowNormalizer({
        source: [...action.contents, ...action.topics],
        identifier: content =>
          getNormalizedContentIdentifiersForContent(content).compoundId,
      });
      return normalizer.normalize();
    }

    default:
      return normalized;
  }
};
